
  var _styles = {
  "button-container": {
    "display": "flex",
    "flexDirection": "row",
    "alignItems": "center",
    "justifyContent": "center"
  },
  "button-text": {
    "color": "rgb(255,255,255)",
    "fontWeight": "500",
    "textAlign": "center",
    "fontFamily": "PingFang SC"
  }
};



  module.exports = _styles;
  